import { badgeTemplateClassifierEntityName } from '../../../../backend/config/classifiers/badge-template-classifier/types';
import { classifierGroups } from '../../../../ui/features/badge-admin-pages/classifierGroups';
import { initBadgeTemplateAdminPageComponent } from '../../../../ui/features/badge-admin-pages/components/BadgeTemplateAdminPage';
import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { getUserState } from '@juvare/platform-sdk-react/ui/stores';
import { useSelector } from 'react-redux';
/**
 * Get Badging Classifier Pages
 *
 * @param props.onGetTemplateDataForBadgeClassifierImageGeneration - create final data for template compilation, e.g. load app specific account info, advanced formatting...
 */
export function useBadgeTemplatesClassifierPages(props) {
    const userState = useSelector(getUserState);
    const pages = [];
    if (userState.badging.badgingEnabled && requireAnySystemPermission(userState, 'manage-badge-templates-classifier')) {
        pages.push({
            label: 'Badge Templates',
            name: badgeTemplateClassifierEntityName,
            path: 'badge-templates',
            groupLabel: classifierGroups.badges,
            component: initBadgeTemplateAdminPageComponent({
                onGetTemplateDataForBadgeClassifierImageGeneration: props.onGetTemplateDataForBadgeClassifierImageGeneration,
                defaultSampleAccountData: props.defaultSampleAccountData,
                defaultFormSettings: props.defaultFormSettings,
            }),
        });
    }
    return pages;
}
